// src/keycloak.ts

import { getKeycloakConfig, isKeycloakEnabled } from './config/authConfig';

type KeycloakLogoutOptions = {
  redirectUri?: string;
};

export type KeycloakInstance = {
  authenticated?: boolean;
  token?: string;
  tokenParsed?: {
    exp?: number;
    [key: string]: unknown;
  };
  login?: () => Promise<void>;
  logout?: (options?: KeycloakLogoutOptions) => Promise<void>;
  updateToken?: (minValidity: number) => Promise<boolean>;
  onTokenExpired?: (() => void) | undefined;
};

let keycloak: KeycloakInstance | null = null;

if (isKeycloakEnabled()) {
  const Keycloak = require('keycloak-js').default;
  keycloak = new Keycloak(getKeycloakConfig());
}

const getLoginRedirectUri = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return `${window.location.origin}/login`;
};

const broadcastAuthLogout = (): void => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('dms-auth-logout'));
  }
};

const redirectToLogin = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};

export const terminateKeycloakSession = async (reason: string): Promise<void> => {
  console.warn(`Keycloak session invalidated: ${reason}`);
  broadcastAuthLogout();

  if (keycloak && typeof keycloak.logout === 'function') {
    try {
      await keycloak.logout({ redirectUri: getLoginRedirectUri() });
      return;
    } catch (error) {
      console.error('Keycloak logout failed:', error);
    }
  }

  redirectToLogin();
};

export default keycloak;
